import React from "react";
import FeedStory from "../feedStory/feedStory";
import { useRssFetch } from "../../custom-hooks/useRssFetch";
import LoadSpinner from "../loadSpinner/LoadSpinner";
import type { FeedItem, Story } from "../../types/rss";

export interface NytFeedProps {
  /** Path segment identifying which feed to load. */
  urlStub: string;
}

const NytFeed = (props: NytFeedProps) => {
  const feed = useRssFetch(
    `https://rss.nytimes.com/services/xml/rss/nyt/${props.urlStub}.xml`
  );

  if (!feed || !feed.items) {
    return <LoadSpinner />;
  }
  const stories: Story[] = [];
  feed.items.forEach(function (entry: FeedItem) {
    const media = entry.media ? entry.media[0] : null;
    stories.push({
      name: entry.title ?? "",
      url: entry.link ?? "",
      author: entry.creator,
      img: media?.$?.url ?? ""
    });
  });

  return (
    <div className="rssFeed">
      {stories.map((story, i) => {
        return <FeedStory key={i} story={story} shouldShowImage={i === 0} />;
      })}
    </div>
  );
};

export default React.memo(NytFeed);
